import { Slider } from "@/components/ui/slider";

export const SliderField = ({ label, value, onChange, min, max, step = 1, format = (v) => `${v} %`, testId, resetTo }) => (
  <div className="space-y-2" data-testid={testId}>
    <div className="flex items-center justify-between text-xs">
      <span className="text-[#6B5F53]">{label}</span>
      <button type="button" onClick={() => onChange(resetTo ?? (min < 0 ? 0 : 100))} className="font-mono text-[#7B5338] hover:underline" title="Réinitialiser" data-testid={`${testId}-value`}>{format(value)}</button>
    </div>
    <Slider value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)} data-testid={`${testId}-slider`} />
  </div>
);
